import { render, staticRenderFns } from "./TableRenovaciones.vue?vue&type=template&id=574e6882&scoped=true"
import script from "./TableRenovaciones.vue?vue&type=script&lang=js"
export * from "./TableRenovaciones.vue?vue&type=script&lang=js"
import style0 from "./TableRenovaciones.vue?vue&type=style&index=0&id=574e6882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e6882",
  null
  
)

export default component.exports